module.exports = __webpack_public_path__ + "media/images/favicons/site-tile-70x70-cda36a132de9144ad16a165f686d50bc.png";